module.exports = __webpack_public_path__ + "img/feature_buy_cn.8bd02eb3.png";